(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 79305:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(65671);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Custom404; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Custom404_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79336);
/* harmony import */ var _Custom404_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Custom404_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37975);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98133);
/* harmony import */ var components_GlobalHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1242);






function Custom404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_GlobalHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Custom404_module_scss__WEBPACK_IMPORTED_MODULE_5___default().emptyWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        name: "empty",
                        width: 96,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Custom404_module_scss__WEBPACK_IMPORTED_MODULE_5___default().emptyText),
                        children: "お探しのページは見つかりません"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                text: "ホーム画面へ"
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 79336:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"Custom404_emptyWrapper__9XGxC","emptyText":"Custom404_emptyText__r87VD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(79305); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);